import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
// import validation from "./validation";
import Services from "@api/services";
import { Helmet } from 'react-helmet-async';

const PropertyInquery = () => {

    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const {
        register,
        handleSubmit,
        reset,
        control,
        watch,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const onSubmit = async (payload) => {
        const realPayload = {
            first_name: payload.firstName,
            last_name: payload.lastName,
            email: payload.email,
            mobile: payload?.phoneNumber.toString(),
            property_name: payload.propertyName,
            address_line_1: payload.address,
            address_line_2: payload.addressLine,
            state_id: payload.state,
            city: payload.city,
            pincode: payload.postalCode,
        };
        try {
            const res = await Services.property.createEnquiryService(realPayload);
            if (res.status === 201) {
                toast.success("Thank you! We've received your inquiry. Our team will contact you soon.", {
                    autoClose: 1000,
                    pauseOnHover: true,
                    position: "center",
                });
                reset();
                navigate('/')
            }
        } catch (error) { }
    };

    const getState = async () => {
        try {
            const state = await Services.globalService.getAllState();
            if (state.status === 200) {
                setStateList(state.data.data);
            }
        } catch (error) { }
    };

    useEffect(() => {
        getState();
    }, []);
    const getCity = async (id) => {
        try {
            const state = await Services.globalService.getAllCitiesByState(id);
            if (state.status === 200) {
                setCityList(state.data.data);
            }
        } catch (error) { }
    };
    const { state } = watch();

    useEffect(() => {
        if (state) {
            getCity(state);
        }
    }, [state]);

    return (
        <>
            <Helmet>
                <link rel="canonical" href={`https://rrooms.in/property-enquiry`} />
            </Helmet>
            <div className='section onboard-form'>
                <div className='container'>
                    <div className='panel'>
                        <h2>Property Enquiry</h2>
                        <p>Partner with us to grow bookings and visibility—submit your details below.</p>
                        <form
                            className="popup-form frontFormAddMember"
                            onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className='col-lg-4'>
                                    <div className="form-group">
                                        <label htmlFor="propertyName" className='label'>Property Name</label>
                                        <input
                                            type="text"
                                            id="propertyName"
                                            placeholder="Enter Property Name"
                                            autoFocus
                                            {...register("propertyName", { required: "Property Name is required" })}
                                            className={`form-control ${errors.propertyName ? "is-invalid" : ""}`}
                                        />
                                        {errors.propertyName && <div className="text-danger fs-7 fw-bold">{errors.propertyName.message}</div>}
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                    <div className="form-group">
                                        <label htmlFor="firstName" className='label'>First Name</label>
                                        <input
                                            type="text"
                                            id="firstName"
                                            placeholder="Enter first name"
                                            {...register("firstName", { required: "First Name is required" })}
                                            className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                                        />
                                        {errors.firstName && <div className="text-danger fs-7 fw-bold">{errors.firstName.message}</div>}
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                    <div className="form-group">
                                        <label htmlFor="lastName" className='label'>Last Name</label>
                                        <input
                                            type="text"
                                            id="lastName"
                                            placeholder="Enter last name"
                                            {...register("lastName", { required: "Last Name is required" })}
                                            className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                                        />
                                        {errors.lastName && <div className="text-danger fs-7 fw-bold">{errors.lastName.message}</div>}
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className="form-group">
                                        <label htmlFor="phoneNumber" className='label'>Phone No.</label>
                                        <input
                                            type="text"
                                            id="phoneNumber"
                                            placeholder="Enter phone number"
                                            maxLength={10}
                                            {...register("phoneNumber", { required: "Phone Number is required" })}
                                            className={`form-control ${errors.phoneNumber ? "is-invalid" : ""}`}
                                        />
                                        {errors.phoneNumber && <div className="text-danger fs-7 fw-bold">{errors.phoneNumber.message}</div>}
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className="form-group">
                                        <label htmlFor="email" className='label'>Email Address</label>
                                        <input
                                            type="email"
                                            id="email"
                                            placeholder="Enter email address"
                                            {...register("email", { required: "Email is required" })}
                                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                        />
                                        {errors.email && <div className="text-danger fs-7 fw-bold">{errors.email.message}</div>}
                                    </div>
                                </div>
                                <div className='col-lg-12'>
                                    <div className="form-group">
                                        <label htmlFor="address" className='label'>Property Address Line 1</label>
                                        <input
                                            type="text"
                                            id="address"
                                            placeholder="Enter property address Line 1"
                                            {...register("address", { required: "Address is required" })}
                                            className={`form-control ${errors.address ? "is-invalid" : ""}`}
                                        />
                                        {errors.address && <div className="text-danger fs-7 fw-bold">{errors.address.message}</div>}

                                        <input
                                            type="text"
                                            id="addressLine"
                                            placeholder="Enter property address Line 2"
                                            {...register("addressLine")}
                                            className="form-control mt-2"
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                    <div className="form-group">
                                        <label className='label'>State</label>
                                        <Controller
                                            control={control}
                                            name="state"
                                            rules={{ required: "State is required" }}
                                            render={({ field }) => (
                                                <select {...field} className={`form-control ${errors.state ? "is-invalid" : ""}`}>
                                                    <option value="" disabled>Select State</option>
                                                    {stateList.map((state) => (
                                                        <option key={state.id} value={state.id}>{state.name}</option>
                                                    ))}
                                                </select>
                                            )}
                                        />
                                        {errors.state && <div className="text-danger fs-7 fw-bold">{errors.state.message}</div>}
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                    <div className="form-group">
                                        <label className='label'>City</label>
                                        <Controller
                                            control={control}
                                            name="city"
                                            rules={{ required: "City is required" }}
                                            render={({ field }) => (
                                                <select {...field} className={`form-control ${errors.city ? "is-invalid" : ""}`}>
                                                    <option value="">Select City</option>
                                                    {cityList.map((city) => (
                                                        <option key={city.id} value={city.id}>{city.name}</option>
                                                    ))}
                                                </select>
                                            )}
                                        />
                                        {errors.city && <div className="text-danger fs-7 fw-bold">{errors.city.message}</div>}
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                    <div className="form-group">
                                        <label htmlFor="postalCode" className='label'>Postal Code</label>
                                        <input
                                            type="text"
                                            id="postalCode"
                                            placeholder="Enter Postal Code"
                                            maxLength={6}
                                            {...register("postalCode", { required: "Postal Code is required" })}
                                            className={`form-control ${errors.postalCode ? "is-invalid" : ""}`}
                                        />
                                        {errors.postalCode && <div className="text-danger fs-7 fw-bold">{errors.postalCode.message}</div>}
                                    </div>
                                </div>
                                <div className='col-lg-12'>
                                    <div className="form-group text-right mb-0">
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PropertyInquery